module.exports = __webpack_public_path__ + "static/media/angle-left.f3ad45e8.svg";